import ConnectionStateMonitor from 'src/shared/connection_state_monitor.js'
import Pusher from 'pusher-js'

export default class PusherClient {
  static connection () {
    if (this.client) { return this.client }

    if (window.gon.use_fake_pusher) {
      this.client = this.fakePusherClient()
    } else {
      this.client = this.pusherClient()
    }

    return this.client
  }

  static fakePusherClient () {
    // This is taken from PusherFake.javascript. It needed tweaking
    // to properly set up with our own fake_pusher_port.
    return new Pusher(
      'dummy_pusher_key',
      {
        wsHost: '127.0.0.1',
        wsPort: window.gon.fake_pusher_port,
        cluster: 'us-east-1'
      }
    )
  }

  static pusherClient () {
    const pusher = new Pusher(window.gon.pusher_key, {
      disableStats: true,
      cluster: 'eu',
      encrypted: true
    })

    pusher.connection.bind('state_change', states => ConnectionStateMonitor.onChange(states))

    return pusher
  }
}
